/**
 * @generated SignedSource<<18a76a8354ec2e3bd2fd15608fd9fad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
export type useWorkspaceTodoEditAddFileMutation$variables = {
  fileIds: ReadonlyArray<string>;
  todoWorkspaceId: string;
};
export type useWorkspaceTodoEditAddFileMutation$data = {
  readonly todoWorkspace: {
    readonly addFiles: {
      readonly descriptionFiles: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly type: FileType | null;
        readonly url: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type useWorkspaceTodoEditAddFileMutation = {
  response: useWorkspaceTodoEditAddFileMutation$data;
  variables: useWorkspaceTodoEditAddFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "fileIds",
    "variableName": "fileIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "addFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceTodoEditAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "addFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76a6d8c27aceac97b4a6202e6e8c9e8f",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditAddFileMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditAddFileMutation(\n  $todoWorkspaceId: ID!\n  $fileIds: [ID!]!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    addFiles(fileIds: $fileIds) {\n      id\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n      descriptionFiles {\n        id\n        type\n        url\n        name\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "35e373c56a76c73740cd8a1bf7bc94af";

export default node;
